/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiCoilChannelModel } from '../../models/api-coil-channel-model';

export interface GetCoilChannelHistory$Params {
  coilSerialNumber: number;
  coilMaterialNumber: string;
  systemSerialNumber: string;
  systemMaterialNumber: number;
}

export function getCoilChannelHistory(http: HttpClient, rootUrl: string, params: GetCoilChannelHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApiCoilChannelModel>>> {
  const rb = new RequestBuilder(rootUrl, getCoilChannelHistory.PATH, 'get');
  if (params) {
    rb.path('coilSerialNumber', params.coilSerialNumber, {});
    rb.path('coilMaterialNumber', params.coilMaterialNumber, {});
    rb.path('systemSerialNumber', params.systemSerialNumber, {});
    rb.path('systemMaterialNumber', params.systemMaterialNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ApiCoilChannelModel>>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getCoilChannelHistory.PATH = '/api/CoilAsync/coilchannelhistory/{coilSerialNumber}/{coilMaterialNumber}/{systemSerialNumber}/{systemMaterialNumber}';
getCoilChannelHistory.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getCoilChannelHistory.ROOTURL = '/coil';
